/* ==========================================================================
   KIMIYA · Comportamiento del tema (prefijo km-)
   Un solo archivo para todas las páginas: cada función revisa primero si su
   elemento existe. Sin librerías externas. Esta página no guarda datos: el
   armador de mensajes solo abre WhatsApp con el texto listo.
   ========================================================================== */
(function () {
  'use strict';

  /* Cada sección enlaza este archivo (así funciona aunque se mueva o se borre una), y el
     navegador lo ejecuta una vez por cada enlace. Sin este candado, en una página con 11
     secciones todo corría 11 veces: un toque mandaba 11 "Contacto" a Meta y el armador de
     citas abría varias pestañas de WhatsApp. */
  if (window.kmIniciado) return;
  window.kmIniciado = true;

  var reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición suave al hacer scroll ---------- */
  function initReveal() {
    var elementos = document.querySelectorAll('.km-reveal:not(.km-visible)');
    if (!elementos.length) return;
    if (reducirMovimiento || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('km-visible'); });
      return;
    }
    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        entrada.target.classList.add('km-visible');
        observador.unobserve(entrada.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    elementos.forEach(function (el, i) {
      var retraso = el.getAttribute('data-km-retraso');
      if (retraso) el.style.transitionDelay = retraso + 'ms';
      observador.observe(el);
    });
  }

  /* ---------- Video real de la portada ----------
     Solo se carga el video que corresponde al tamaño de pantalla, y ninguno si
     la persona pidió reducir el movimiento (se queda la foto). */
  function initVideos() {
    var videos = document.querySelectorAll('video[data-km-src]');
    if (!videos.length || reducirMovimiento) return;
    var esEscritorio = window.matchMedia('(min-width: 750px)').matches;
    videos.forEach(function (video) {
      var tipo = video.getAttribute('data-km-tipo');
      if ((tipo === 'escritorio') !== esEscritorio) return;
      video.src = video.getAttribute('data-km-src');
      video.muted = true;
      var promesa = video.play();
      if (promesa && promesa.catch) promesa.catch(function () {});
    });
  }

  /* ---------- Comparador antes / después ---------- */
  function initComparadores() {
    document.querySelectorAll('[data-km-comparador]').forEach(function (caja) {
      var asa = caja.querySelector('.km-comparador__asa');
      if (!asa) return;
      var pos = 50;
      var arrastrando = false;

      function poner(valor) {
        pos = Math.max(0, Math.min(100, valor));
        caja.style.setProperty('--km-pos', pos + '%');
        asa.setAttribute('aria-valuenow', Math.round(pos));
      }

      function desdeEvento(e) {
        var rect = caja.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
        poner((x / rect.width) * 100);
      }

      asa.addEventListener('pointerdown', function (e) {
        arrastrando = true;
        asa.setPointerCapture && asa.setPointerCapture(e.pointerId);
        desdeEvento(e);
      });
      asa.addEventListener('pointermove', function (e) {
        if (arrastrando) desdeEvento(e);
      });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (tipo) {
        asa.addEventListener(tipo, function () { arrastrando = false; });
      });
      caja.addEventListener('click', function (e) {
        if (e.target.closest('.km-comparador__asa')) return;
        desdeEvento(e);
      });
      asa.addEventListener('keydown', function (e) {
        var paso = e.shiftKey ? 10 : 4;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { poner(pos - paso); e.preventDefault(); }
        if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { poner(pos + paso); e.preventDefault(); }
        if (e.key === 'Home') { poner(0); e.preventDefault(); }
        if (e.key === 'End') { poner(100); e.preventDefault(); }
      });

      /* Pequeña pista de movimiento la primera vez que se ve */
      if (!reducirMovimiento && 'IntersectionObserver' in window) {
        var visto = false;
        var obs = new IntersectionObserver(function (entradas) {
          if (visto || !entradas[0].isIntersecting) return;
          visto = true;
          obs.disconnect();
          var t0 = null;
          function paso(t) {
            if (arrastrando) return;
            if (!t0) t0 = t;
            var p = (t - t0) / 1400;
            if (p >= 1) { poner(50); return; }
            poner(50 + Math.sin(p * Math.PI * 2) * 14);
            requestAnimationFrame(paso);
          }
          requestAnimationFrame(paso);
        }, { threshold: 0.6 });
        obs.observe(caja);
      }
    });
  }

  /* ---------- Visor de fotos de la galería ---------- */
  function initVisor() {
    var botones = document.querySelectorAll('[data-km-ampliar]');
    if (!botones.length) return;
    var visor = document.createElement('dialog');
    visor.className = 'km-visor';
    visor.setAttribute('aria-label', 'Foto ampliada');
    visor.innerHTML = '<img alt=""><button type="button" class="km-visor__cerrar" aria-label="Cerrar">&times;</button>';
    document.body.appendChild(visor);
    var img = visor.querySelector('img');
    visor.querySelector('button').addEventListener('click', function () { visor.close(); });
    visor.addEventListener('click', function (e) { if (e.target === visor) visor.close(); });
    botones.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var fuente = boton.getAttribute('data-km-ampliar');
        var miniatura = boton.querySelector('img');
        img.src = fuente;
        img.alt = miniatura ? miniatura.alt : '';
        if (typeof visor.showModal === 'function') {
          visor.showModal();
        } else {
          window.open(fuente, '_blank', 'noopener');
        }
      });
    });
  }

  /* ---------- Armador del mensaje para agendar ---------- */
  function initAgendar() {
    document.querySelectorAll('[data-km-agendar]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var numero = form.getAttribute('data-km-numero');
        var plantilla = form.getAttribute('data-km-plantilla') || '';
        var plantillaProductos = form.getAttribute('data-km-plantilla-productos') || '';
        var soloProductos = form.getAttribute('data-km-solo-productos') || '';
        var valor = function (nombre) {
          var marcado = form.querySelector('input[name="' + nombre + '"]:checked');
          return marcado ? marcado.value : '';
        };
        var vehiculo = valor('vehiculo').toLowerCase();
        var servicio = valor('servicio');
        var dia = valor('dia').toLowerCase();
        var campoNombre = form.querySelector('input[name="nombre"]');
        var nombre = campoNombre ? campoNombre.value.trim() : '';

        var mensaje;
        if (soloProductos && servicio === soloProductos) {
          mensaje = plantillaProductos;
        } else {
          mensaje = plantilla
            .replace('{servicio}', servicio.toLowerCase())
            .replace('{vehiculo}', vehiculo)
            .replace('{dia}', dia);
          if (nombre) {
            mensaje += ' Mi nombre es ' + nombre + '.';
          }
        }
        var url = 'https://wa.me/' + numero + '?text=' + encodeURIComponent(mensajeConOrigen(mensaje));
        medirWhatsApp('agendar');
        window.open(url, '_blank', 'noopener');
      });
    });
  }

  /* ---------- Barra fija de WhatsApp en el celular ---------- */
  function initBarra() {
    var barra = document.querySelector('[data-km-barra]');
    if (!barra) return;
    document.body.classList.add('km-con-barra');
    var umbral = parseInt(barra.getAttribute('data-km-umbral') || '400', 10);
    var pendiente = false;
    function revisar() {
      pendiente = false;
      barra.classList.toggle('km-barra--visible', window.scrollY > umbral);
    }
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(revisar);
    }, { passive: true });
    revisar();
  }

  /* ---------- Menú del celular ---------- */
  function initMenu() {
    var menu = document.querySelector('[data-km-menu]');
    if (!menu) return;
    var cabecera = menu.closest('.km-header');
    function medir() {
      if (cabecera) document.documentElement.style.setProperty('--km-header-alto', cabecera.getBoundingClientRect().bottom + 'px');
    }
    menu.addEventListener('toggle', medir);
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { menu.removeAttribute('open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.hasAttribute('open')) {
        menu.removeAttribute('open');
        menu.querySelector('summary').focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (menu.hasAttribute('open') && !menu.contains(e.target)) menu.removeAttribute('open');
    });
  }

  /* ---------- Medición: cada toque a WhatsApp cuenta como "Contacto" en Meta ----------
     El píxel principal lo instala la app de Facebook & Instagram en un entorno aislado y no
     mide estos clics. Aquí se carga el mismo píxel solo al primer toque (la página no pesa
     más para nadie) y sin PageView, para no duplicar visitas. También se avisa a Shopify. */
  var pixelListo = false;
  function cargarPixel(id) {
    if (pixelListo || !id) return;
    pixelListo = true;
    if (!window.fbq) {
      var f = window.fbq = function () { f.callMethod ? f.callMethod.apply(f, arguments) : f.queue.push(arguments); };
      if (!window._fbq) window._fbq = f;
      f.push = f; f.loaded = true; f.version = '2.0'; f.queue = [];
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(s);
    }
    window.fbq('init', id);
  }

  function medirWhatsApp(origen) {
    var pagina = location.pathname === '/' ? 'inicio' : location.pathname.replace(/^\/pages\//, '').replace(/\//g, '-');
    var datos = { content_name: 'whatsapp', content_category: pagina, origen: origen || '' };
    try {
      cargarPixel(window.kmPixel);
      if (window.fbq) window.fbq('track', 'Contact', datos);
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('km_whatsapp', datos);
      }
    } catch (e) {}
  }

  /* ---------- De dónde viene la visita (la "pulsera") ----------
     Meta agrega "fbclid" a la dirección cuando alguien toca un anuncio, y los enlaces de la
     campaña llevan utm_source=meta. Las demás puertas llevan su propia pulsera:
       bio de Instagram  ?utm_source=instagram&utm_medium=bio
       volante (QR)      ?utm_source=volante
       estados de WhatsApp ?utm_source=whatsapp
       Google Maps       ?utm_source=google
     El origen se recuerda durante la sesión y cambia la frase del mensaje de WhatsApp, así el
     agente y la hoja anotan el canal correcto. Sin pulsera, el mensaje dice "Vengo de la página web". */
  var FRASE_WEB = 'Vengo de la página web';
  var FRASES = {
    anuncio: 'Vengo del anuncio (página web)',
    bio: 'Vengo de Instagram (página web)',
    volante: 'Vengo del volante (página web)',
    whatsapp: 'Vengo de WhatsApp (página web)',
    google: 'Vengo de Google (página web)'
  };

  function origenVisita() {
    var origen = '';
    try {
      var p = new URLSearchParams(location.search);
      var fuente = (p.get('utm_source') || '').toLowerCase();
      var medio = (p.get('utm_medium') || '').toLowerCase();
      var nuevo = '';
      if (/^(bio|perfil|organico|orgánico|historia|historias)$/.test(medio) && /^(instagram|ig)$/.test(fuente)) nuevo = 'bio';
      else if (p.get('fbclid') || /^(meta|facebook|fb|instagram|ig)$/.test(fuente)) nuevo = 'anuncio';
      else if (/^(volante|qr|rotulo|rótulo)$/.test(fuente)) nuevo = 'volante';
      else if (/^(whatsapp|wa|estado|estados)$/.test(fuente)) nuevo = 'whatsapp';
      else if (/^(google|maps|gmb)$/.test(fuente)) nuevo = 'google';
      if (nuevo) sessionStorage.setItem('kmOrigen', nuevo);
      /* Código del anuncio: utm_content trae el nombre ("V1 · Carro 2 horas"); se guarda "V1" para anotarlo en el chat. */
      var contenido = (p.get('utm_content') || '').trim();
      var codigo = contenido.match(/^([A-Za-z]{1,2}\d{1,2})(?![A-Za-z0-9])/);
      if (codigo) sessionStorage.setItem('kmRef', codigo[1].toUpperCase());
      origen = sessionStorage.getItem('kmOrigen') || '';
    } catch (e) {}
    return FRASES[origen] ? origen : '';
  }

  function vieneDeAnuncio() {
    return origenVisita() === 'anuncio';
  }

  function mensajeConOrigen(texto) {
    var origen = origenVisita();
    if (!origen) return texto;
    var frase = FRASES[origen];
    if (origen === 'anuncio') {
      var ref = '';
      try { ref = sessionStorage.getItem('kmRef') || ''; } catch (e) {}
      if (ref) frase = frase.replace(')', ', ref: ' + ref + ')');
    }
    return String(texto).replace(FRASE_WEB, frase);
  }

  function marcarEnlace(enlace) {
    if (!origenVisita()) return;
    try {
      var url = new URL(enlace.href);
      var texto = url.searchParams.get('text');
      if (texto && texto.indexOf(FRASE_WEB) !== -1) {
        url.searchParams.set('text', mensajeConOrigen(texto));
        enlace.href = url.toString().replace(/\+/g, '%20');
      }
    } catch (e) {}
  }

  function initMedicion() {
    /* Si la visita viene de un anuncio, el píxel se activa al llegar (sin PageView). Así Meta
       guarda el clic del anuncio y puede atribuirle el "Contacto" aunque la persona cambie de página. */
    try {
      if (new URLSearchParams(location.search).get('fbclid')) cargarPixel(window.kmPixel);
    } catch (e) {}
    vieneDeAnuncio();

    document.addEventListener('click', function (e) {
      var enlace = e.target.closest && e.target.closest('a[href*="wa.me/"]');
      if (!enlace) return;
      /* Un segundo toque mientras abre no hace nada: así no se abren dos chats ni se cuentan dos "Contacto". */
      if (enlace.classList.contains('km-cargando') || enlace.classList.contains('km-listo')) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      estadosDelBoton(enlace);
      marcarEnlace(enlace);
      var seccion = enlace.closest('[id^="shopify-section-"]');
      medirWhatsApp(seccion ? seccion.id.replace(/^shopify-section-(template--\d+__|sections--\d+__)?/, '') : '');
    }, true);
  }

  /* ---------- Estados del botón de WhatsApp ----------
     Al tocarlo se desactiva, mientras abre dice "Abriendo WhatsApp…" con un círculo que gira,
     y al terminar confirma "Listo, siga en WhatsApp". Luego vuelve a su texto. */
  function estadosDelBoton(enlace) {
    if (!enlace.classList.contains('km-btn')) return;
    var original = enlace.innerHTML;
    var ancho = enlace.offsetWidth;
    enlace.style.minWidth = ancho + 'px';
    enlace.classList.add('km-cargando');
    enlace.setAttribute('aria-busy', 'true');
    enlace.innerHTML = '<span class="km-giro" aria-hidden="true"></span><span>Abriendo WhatsApp…</span>';
    setTimeout(function () {
      enlace.classList.remove('km-cargando');
      enlace.classList.add('km-listo');
      enlace.removeAttribute('aria-busy');
      enlace.innerHTML = '<span aria-hidden="true">✓</span><span>Listo, siga en WhatsApp</span>';
    }, 1200);
    setTimeout(function () {
      enlace.classList.remove('km-listo');
      enlace.innerHTML = original;
      enlace.style.minWidth = '';
    }, 5000);
  }

  /* ---------- Franja de oferta: mide su alto para que se vaya con el scroll ---------- */
  function initAviso() {
    var aviso = document.querySelector('.km-aviso');
    if (!aviso) return;
    function medir() {
      document.documentElement.style.setProperty('--km-aviso-alto', aviso.offsetHeight + 'px');
    }
    medir();
    window.addEventListener('resize', medir, { passive: true });
  }

  function iniciar() {
    initAviso();
    initMedicion();
    initReveal();
    initVideos();
    initComparadores();
    initVisor();
    initAgendar();
    initBarra();
    initMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  /* El editor de Shopify recarga secciones sueltas: volver a iniciar */
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initVideos();
    initComparadores();
    initVisor();
    initAgendar();
  });
})();
